"use client";

import QuickSearchSwiper from "@/app/(homepage)/dashboard/quickSearchSwiper";
import AlgoliaSearchField from "@/app/layouts/standard/header/search-bar/algoliaSearchField";
import { AppState } from "@/store/store";
import { Suspense } from "react";
import { useSelector } from "react-redux";
import style from "./searchComponent.module.scss";

export default function SearchComponent({ searchData }: { searchData: SearchData | null }) {
  const searchDropdownVisible = useSelector((state: AppState) => state.searchDropdownVisibleSlice.isVisible);

  return (
    <div id="dashboard" className={style.searchContainer}>
      <div
        id="homePageSearchDashboard"
        className={`${style.homePageSearchDashboard} ${searchDropdownVisible ? style.homePageSearchDropdownVisible : ""}`}
      >
        <Suspense>
          <AlgoliaSearchField isHomePage />
        </Suspense>
      </div>
      <QuickSearchSwiper searchData={searchData} />
    </div>
  );
}
